import Cookie from 'js-cookie'

const cookieDomain = '.' + location.hostname

const queryParams = {}
window.location.href.slice().replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    queryParams[key] = value
})

const utmFields = {};
// Set utm cookie if parameters is present in query
if (queryParams.utm_source)     utmFields.source    = queryParams.utm_source
if (queryParams.utm_medium)     utmFields.medium    = queryParams.utm_medium
if (queryParams.utm_campaign)   utmFields.campaign  = queryParams.utm_campaign
if (queryParams.utm_term)       utmFields.term      = queryParams.utm_term
if (queryParams.utm_content)    utmFields.content   = queryParams.utm_content

if (Object.keys(utmFields).length) {
    Cookie.set('utm', JSON.stringify(utmFields), { expires: 365 * 2, domain: cookieDomain })
}

// Set kayakclickid cookie if parameter is present in query
if (queryParams.kayakclickid) {
    Cookie.set('kayakclickid', queryParams.kayakclickid, { expires: 365 * 2, domain: cookieDomain })
}

// Set referrer cookie if referrer exist
if (window.document.referrer) {
    let currentHostReferrer = false
    try {
        const url = new URL(window.document.referrer)
        currentHostReferrer = url.hostname === window.location.hostname
    } catch (e) {}

    if (!currentHostReferrer)
        Cookie.set('http_referrer', window.document.referrer, { expires: 365 * 2, domain: cookieDomain })
}

export default {
    install() {},
}



// WEBPACK FOOTER //
// ./src/plugins/marketing_source.js